import SHA256 from 'crypto-js/sha256';
import api from './api';
import { setStorage, removeStorage } from './localstorage';

export const login = async (newMobileNo, otp, ref, merchantUuid) => {
  try {
    // const hashTaxId = SHA256(taxId).toString();
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/auth/login-citizen-mobileno-confirmOtp`,
      {
        mobileNo: newMobileNo,
        otp,
        ref,
        merchantUuid
      },
    );
    const token = data?.token;
    await setStorage('token', token);
    await setStorage(
      'username',
      `${data.first_name_eng} ${data.last_name_eng}`,
    );
    return { success: true, result: true };
  } catch (e) {
    return { success: false, result: e.response.data.error };
    // throw new Error(e);
  }
};

export const loginWithPWD = async (payload) => {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_API_URL}/auth/login-user`, payload);
    const token = data?.access_token;
    await setStorage('token', token);
    
    return { success: true, result: true };
  } catch (error) {
    return { success: false, result: error.response.data.error };
  }
}

export const loginAdmin = async (username, password, taxId, typeTax) => {
  try {
    if (typeTax === 'citizen') {
      const hashTaxId = SHA256(taxId).toString();
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/auth/login-citizen`,
        {
          username,
          password,
          taxId,
          hashTaxId,
        },
      );
      const token = data?.token;
      await setStorage('token', token);
      await setStorage(
        'username',
        `${data.first_name_eng} ${data.last_name_eng}`,
      );
      return data;
    } else if (typeTax === 'business') {
      const hashTaxId = SHA256(taxId).toString();
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/auth/login-business`,
        {
          username,
          password,
          taxId,
          hashTaxId,
        },
      );
      await setStorage('username', `${data.first_name_eng} ${data.last_name_eng}`);
      return data;
    }
    //   await setStorage('remember', JSON.stringify(remember));
  } catch (e) {
    throw e.response.data
  }
};

export const logout = async () => {
  removeStorage('token');
  removeStorage('remember');
  removeStorage('username');
};
